export const PERFORMANCE_MONITOR_ENABLED = typeof window !== 'undefined'
  && new URLSearchParams(window.location.search).get('perf') === '1';

export const PDF_RENDER_EVENT = 'izqlt:pdf-render';
export const BOARD_FRAME_EVENT = 'izqlt:board-frame';

export interface PdfRenderMetric {
  page: number;
  milliseconds: number;
  cached: boolean;
}

export function reportPdfRender(metric: PdfRenderMetric): void {
  if (!PERFORMANCE_MONITOR_ENABLED) return;
  window.dispatchEvent(new CustomEvent(PDF_RENDER_EVENT, { detail: metric }));
}

export function reportBoardFrame(activeStroke: boolean): void {
  if (!PERFORMANCE_MONITOR_ENABLED || !activeStroke) return;
  window.dispatchEvent(new CustomEvent(BOARD_FRAME_EVENT));
}
